export default __webpack_public_path__ + "static/media/Pido.me.f91df0e0.svg";